<template>
  <div :class="{ 'w-full': fullWidth }">
    <div class="w-full flex justify-center">
      <button
        ref="dateButton"
        :aria-label="toggled ? $t('quote.open-availability-filter') : $t('quote.close-availability-filter')"
        class="bg-white border-neutral-300 rounded-md py-2 px-4 border text-neutral-600 focus:ring-indigo flex items-center justify-center space-x-3"
        :class="[
          toggled ? 'bg-neutral-200' : 'hover:bg-neutral-100',
          { 'w-full text-left': fullWidth },
        ]"
        type="button"
        @click="$emit('menu-press')"
      >
        <span :class="{ 'w-full': fullWidth }">{{ $t('app.filter-by-availability') }}</span>
        <fa
          v-if="toggled"
          :icon="['fal', 'times']"
          class="text-base"
        />
        <fa
          v-else
          :icon="['fal', 'angle-down']"
          class="text-base rotates"
          :class="{
            'fa-rotate-180': open,
          }"
        />
      </button>
    </div>
    <div
      ref="dayPicker"
      class="relative bg-black flex justify-center lg:justify-start"
    >
      <vetster-day-picker
        v-show="open"
        :date="today"
        :timezone="inputs.timezone"
        class="absolute top-1 w-80 shadow-lg z-10 bg-white p-2 rounded-lg border border-neutral-300"
        @change="$emit('change', $event)"
        @update="handleDay"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import VetsterDayPicker from '@/components/VetsterDayPicker';
import ClickAway from '@/mixins/ClickAway';

export default {
  name: 'VetsterAvailabilityButton',

  components: { VetsterDayPicker },

  mixins: [ClickAway],

  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: null,
    },
    /**
     * PHP CityPartnersRepository or StatePartnersRepository always search
     * for partner results available from Carbon::today() which is in UTC.
     * Previous search filters won't be applied so the user must select a
     * VetsterDayPicker date for their desired results.
     */
    today: {
      type: String,
      required: true,
    },
    toggled: {
      type: Boolean,
      default: null,
    },
  },

  computed: {
    ...mapState('search', ['inputs']),
  },

  mounted() {
    document.addEventListener('click', this.registerClickAway);
  },

  methods: {
    async handleDay(date) {
      this.$store.commit('search/setDates', { date_from: date });
      this.$store.commit('search/setInputs', { date_from: date });
    },
    registerClickAway(event) {
      this.hideOnClickAway(
        event,
        this.$refs.dateButton,
        () => { this.$emit('close'); },
        this.$refs.dayPicker,
      );
    },
  },
};
</script>
